import React, { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import MustBePremiumDialog from '@components/shared/dialogs/MustBePremiumDialog'
import AddToCollectionDialog from '@components/shared/dialogs/collection/AddToCollectionDialog'
import { useSelection } from '@providers/SelectionProvider'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'

import type Score from '@models/Score'

const AddToCollectionButton: React.FC = () => {
  const session = useSession()
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)

  const onClick = () => {
    if (!session.hasPremiumFeatures()) {
      openDialog('require_premium_collections')
      return
    }
    openDialog('add_to_collection')
  }

  const { selectedItems } = useSelection<Score>()
  const scoreIds = useMemo(() => selectedItems.map((item) => item.external_id), [selectedItems])

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="font-medium ml-2.5"
        onClick={onClick}
        disabled={!selectedItems.length}>
        {t('action.addToCollection')}
      </Button>
      <AddToCollectionDialog data={{ type: 'scoreList', ids: scoreIds }} />
      <MustBePremiumDialog
        title={t('action.addToCollection')}
        action={t('action.addToCollection')}
        name="require_premium_collections"
      />
    </>
  )
}

export default AddToCollectionButton
